/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable ember/no-controllers */
/* eslint-disable ember/no-classic-classes */
import { inject as service } from '@ember/service';
import { reads, gt } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';
import { fmtStyle } from '@intercom/pulse/lib/computed-properties';

export default Controller.extend({
  intercomEventService: service(),
  appController: controller('apps.app'),
  app: reads('appController.model'),
  // eslint-disable-next-line @intercom/intercom/no-legacy-modal
  modalService: service(),
  mailchimpController: controller('apps.app.import.mailchimp'),
  importing: gt('userCreateProgress', 0),
  userCreateProgress: 0,
  importComplete: false,
  hasNoCustomTag: true,
  usersOrLeads: 'users',
  shouldCombineCreatedOrUpdatedCounts: gt('peopleCreatedOrUpdated', 0),
  shouldShowImportSummary: false,
  realTimeEventService: service(),
  progressWidth: fmtStyle('width: %@%', 'userCreateProgress'),

  init() {
    this._super(...arguments);
    this.realTimeEventService.subscribeTopics(['mailchimp-import-user-create-progress']);
    this.realTimeEventService.on(
      'MailchimpImportUserCreateProgress',
      this,
      'onMailchimpImportUserCreateProgress',
    );
  },

  willDestroy() {
    this.realTimeEventService.unsubscribeTopics(['mailchimp-import-user-create-progress']);
    this.realTimeEventService.off(
      'MailchimpImportUserCreateProgress',
      this,
      'onMailchimpImportUserCreateProgress',
    );
    this._super(...arguments);
  },

  onMailchimpImportUserCreateProgress(data) {
    let mailchimpImport = this.model;
    let percentCompleted = parseInt(data.percentComplete, 10);

    if (mailchimpImport.get('listId') !== data.listId) {
      return;
    }
    if (this.userCreateProgress > percentCompleted) {
      return;
    }

    this.set('userCreateProgress', percentCompleted);
    if (percentCompleted === 100) {
      this.set('mailchimpController.currentStep', 4);
      this.model.reload().then(() => {
        if (this.get('model.importSummary')) {
          let mailchimpImport = this.model;
          this.set('peopleCreated', mailchimpImport.get('importSummary').users_created);
          this.set('peopleUpdated', mailchimpImport.get('importSummary').users_updated);
          this.set(
            'peopleCreatedOrUpdated',
            parseInt(mailchimpImport.get('importSummary').users_created_or_updated, 10),
          );
          this.set('importComplete', true);
          this.mailchimpController.set('currentStep', 5);
        }
      });
    }
  },

  actions: {
    toggleImportSummary() {
      this.toggleProperty('shouldShowImportSummary');
    },
    finish(shouldTransitionToSummary) {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'mailchimp-import-finished',
        object: 'mailchimp-import',
      });

      if (window.opener) {
        window.opener.importSuccessful = true;
        if (shouldTransitionToSummary) {
          window.opener.shouldTransitionToSummary = true;
        }
        window.close();
      }
    },
    openTaggingModal(component, model, options) {
      this.modalService.openModal(component, model, options);
    },
  },
});
